import React from "react"
import styled from "styled-components"
import { CalculationSchemaKeys } from "src/features/calculator/schema"

type Props = {
  label: string
  placeholder?: string
  name: CalculationSchemaKeys
  errorText?: string
  required?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  defaultValue: string
}

export function DateInputField({
  label,
  placeholder,
  name,
  errorText,
  required = false,
  onChange,
  defaultValue,
}: Props) {
  return (
    <StyledFieldWrapperDiv>
      <label htmlFor={`date-input-${name}`}>
        {label} {required && <span>*</span>}
      </label>
      <StyledFormFieldDiv>
        <input
          id={`date-input-${name}`}
          aria-label={label}
          aria-required={required}
          aria-invalid={!!errorText}
          type="date"
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultValue}
        />
      </StyledFormFieldDiv>
      {errorText && (
        <StyledErrorSpan role="alert" aria-live="polite">
          {errorText}
        </StyledErrorSpan>
      )}
    </StyledFieldWrapperDiv>
  )
}

const StyledFieldWrapperDiv = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

const StyledFormFieldDiv = styled("div")`
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
`

const StyledErrorSpan = styled("span")`
  color: red;
`
